// LICENSE_CODE ZON
'use strict';/*jslint ts:true, react: true*/
import React, {useMemo} from 'react';
// @ts-ignore
import {proxy_countries} from '/protocol/pub/countries.js';
// @ts-ignore
import {fmt_country} from '/www/hola/pub/unblock_util.js';
import cn from 'classnames';
import '/www/hola/pub/css/wbm_flags.less';

interface i_country {
    value: string;
    title: string;
    cls: string;
    rendered_item: JSX.Element;
}
interface i_countries {
    [propname: string]: i_country;
}
type sort_fn = (a: string, b: string, prev: number)=>number;
export const use_countries =
    (size?: string, wrap_cls?: string, fl_cls?: string,
        fn?: sort_fn, flag_in_title?: boolean, only_flag?: boolean)=>
            {
    return useMemo(()=>{
        const bext = proxy_countries.bext;
        const countries_by_code = {} as i_countries;
        const countries:i_country[] = bext
            .map(c=>({value: c, title: fmt_country(c), cls: c.toLowerCase()}))
            .sort((a, b)=>{
                let res = 0;
                if (a.value < b.value)
                    res = -1;
                else
                    res = a.value > b.value ? 1 : 0;
                return fn ? fn(a.value, b.value, res) : res;
            })
            .map(item=>{
              const new_item = {...item, rendered_item: <span
                className={cn(wrap_cls, size||'f32')}>
                <span className={cn(fl_cls, item.cls)}/>
                {!only_flag &&
                  <span className="name">{item.title}</span>
                }
              </span>};
              if (flag_in_title)
                new_item.title = new_item.rendered_item;
              countries_by_code[item.value] = new_item;
              return new_item;
          });
        return {countries, countries_by_code};
    }, []);
};
